import styled, { css } from 'styled-components';

export const WarningBannerElement = styled.div<{ isFullBorder: boolean }>`
  align-items: center;
  background: #9a201c;
  color: #ffffff;
  display: flex;
  flex: none;
  justify-content: center;
  min-height: 50px;
  padding: 10px 0;
  text-align: center;
  ${({ isFullBorder }) =>
    isFullBorder &&
    css`
      border: 2px solid #ffffff;
      border-radius: 10px;
    `};

  span {
    width: 70%;
  }

  @media (max-width: 480px) {
    padding: 12px;

    span {
      width: 100%;
    }
  }
`;
